import EmptyState from '@components/v2/ui/EmptyState/EmptyState';
import { Stack } from '@mui/material';
import LangEnum from '../../../lang/LangEnum';

interface TargetErrorStateProps {
  title: LangEnum;
  onRetry?: () => void;
  onGoBack?: () => void;
}

const TargetErrorState = ({ title, onRetry, onGoBack }: TargetErrorStateProps) => {
  const retryAction = onRetry && { label: LangEnum.GLOBAL_TRY_AGAIN, onClick: onRetry };
  const goBackAction = onGoBack && { label: LangEnum.GLOBAL_GO_BACK, onClick: onGoBack };

  return (
    <Stack sx={{ flex: '1 0 auto', alignItems: 'center', justifyContent: 'center', p: 3 }}>
      <EmptyState
        title={{ text: title }}
        action={{ primary: retryAction ?? goBackAction, secondary: retryAction && goBackAction }}
      />
    </Stack>
  );
};

export default TargetErrorState;
